/**
 * Log Sampling
 * Implementa sampling inteligente de logs DEBUG em produção
 */

// Taxa de sampling para logs DEBUG em produção (5%)
const DEBUG_SAMPLE_RATE = 0.05;

// Lista de usuários flagged que devem ter 100% dos logs DEBUG
const flaggedUsers = new Set<string>();

/**
 * Verifica se deve fazer sample do log DEBUG
 */
export function shouldSample(): boolean {
  // Em dev, sempre logar
  if (!import.meta.env.PROD) {
    return true;
  }

  // Verificar se usuário está flagged para debug
  const userId = getUserIdFromContext();
  if (userId && flaggedUsers.has(userId)) {
    return true;
  }

  // Sampling aleatório baseado na taxa configurada
  return Math.random() < DEBUG_SAMPLE_RATE;
}

/**
 * Adiciona usuário à lista de debug (100% dos logs DEBUG)
 */
export function enableDebugForUser(userId: string) {
  flaggedUsers.add(userId);
  
  // Auto-remover após 1 hora
  setTimeout(() => {
    flaggedUsers.delete(userId);
  }, 60 * 60 * 1000);
}

/**
 * Remove usuário da lista de debug
 */
export function disableDebugForUser(userId: string) {
  flaggedUsers.delete(userId);
}

/**
 * Verifica se usuário está com debug habilitado
 */
export function isDebugEnabledForUser(userId: string): boolean {
  return flaggedUsers.has(userId);
}

/**
 * Helper para obter user_id do contexto
 */
function getUserIdFromContext(): string | null {
  try {
    // Tentar pegar do unified logger
    const { unifiedLogger } = require('./unified-logger');
    return (unifiedLogger as any).userId || null;
  } catch {
    return null;
  }
}

/**
 * Configura taxa de sampling (para testes/admin)
 */
let customSampleRate: number | null = null;

export function setSampleRate(rate: number) {
  if (rate < 0 || rate > 1) {
    throw new Error('Sample rate must be between 0 and 1');
  }
  customSampleRate = rate;
}

export function getSampleRate(): number {
  return customSampleRate !== null ? customSampleRate : DEBUG_SAMPLE_RATE;
}
